define(['es6!services/services'], services => services);
